import { render } from "./MenuButton.vue?vue&type=template&id=35cdbc66"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
script.render = render

export default script